/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Prescription from './prescription';
import PrescriptionDetail from './prescription-detail';
import PrescriptionUpdate from './prescription-update';
import PrescriptionDeleteDialog from './prescription-delete-dialog';

const PrescriptionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Prescription />} />
    <Route path="new" element={<PrescriptionUpdate />} />
    <Route path=":id">
      <Route index element={<PrescriptionDetail />} />
      <Route path="edit" element={<PrescriptionUpdate />} />
      <Route path="delete" element={<PrescriptionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PrescriptionRoutes;
